/**
 * Copyright (c) Riskaware 2017
 */

import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from "redux-thunk";
import { AoiReducer } from "./aoi/reducer";
import { AuditsReducer } from "./audits/reducer";
import { ContourConfigReducer } from './contours/reducer.jsx';
import { IncidentReducer } from './incident/reducer';
import { KeyBuildReducer } from "./keyBuild/reducer";
import { MapReducer } from "./map/reducer";
import { MetReducer } from './met/reducer';
import { metPresetsReducer } from './metPresets/reducer.jsx';
import { PopupReducer } from "./popups/reducer";
import { ResultsReducer } from './results/reducer';
import { ScenarioReducer } from './scenario/reducer';
import { SetupMenuReducer } from './setupMenu/reducer';
import { SimulationReducer } from './simulation/reducer';
import { UserReducer } from './user/reducer';
export class Store {

    /*
     * Get the store
     */
    static getStore() {

        const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

        // Combine Reducers
        var reducers = combineReducers({
            mapState: MapReducer.mapInfo,
            mapFilterState: MapReducer.mapFilterInfo,
            popupState: PopupReducer.popupInfo,
            scenarioState: ScenarioReducer.scenarioInfo,
            auditState: AuditsReducer.auditsInfo,
            incidentState: IncidentReducer.incidentsInfo,
            aoiState: AoiReducer.aoisInfo,
            keyBuildState: KeyBuildReducer.keyBuildsInfo,
            simulationState: SimulationReducer.simulationInfo,
            metState: MetReducer.metInfo,
            metPresetsState: metPresetsReducer,
            setupMenuState: SetupMenuReducer.setupMenuInfo,
            resultsState: ResultsReducer.resultsInfo,
            userState: UserReducer.userInfo,
            contourConfigState: ContourConfigReducer.contourConfigInfo
        });

        return createStore(reducers, composeEnhancer(applyMiddleware(thunk)));
    }
}